import {
    DataTable,
    DateField,
    List,
    ReferenceField,
    SearchInput,
    SelectInput,
    TextField
} from '@/components/admin';
import { Card } from '@/components/ui/card';
import { PackageCheck } from 'lucide-react';
import { StatusBadgeField } from '../documents/shared/StatusBadge';

const grnFilters = [
    <SearchInput source="q" alwaysOn />,
    <SelectInput source="status" choices={[
        { id: 'draft', name: 'Draft' },
        { id: 'received', name: 'Received' },
        { id: 'qa_passed', name: 'QA Passed' },
        { id: 'qa_failed', name: 'QA Failed' },
    ]} />,
];

export const GRNList = () => {
    return (
        <List
            filters={grnFilters}
            sort={{ field: 'created_at', order: 'DESC' }}
            title={
                <div className="flex items-center gap-2">
                    <PackageCheck className="w-6 h-6 text-muted-foreground" />
                    <span>Goods Receipt Notes</span>
                </div>
            }
        >
            <Card className="py-0 overflow-hidden">
                <DataTable rowClick="show">
                    <DataTable.Col source="reference" label="GRN No." className="font-bold text-foreground" />
                    <DataTable.Col label="PO">
                        <ReferenceField source="po_id" reference="purchase_orders" link={false}>
                            <TextField source="reference" className="text-info font-medium font-mono text-sm" />
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col label="Vendor">
                        <ReferenceField source="vendor_id" reference="vendors" link={false}>
                            <TextField source="name" />
                        </ReferenceField>
                    </DataTable.Col>
                    <DataTable.Col label="Received">
                        <DateField source="received_date" />
                    </DataTable.Col>
                    <DataTable.Col label="Status">
                        <StatusBadgeField source="status" />
                    </DataTable.Col>
                    <DataTable.Col label="Created">
                        <DateField source="created_at" showTime />
                    </DataTable.Col>
                </DataTable>
            </Card>
        </List>
    );
};
